// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IEmployeeChoiceDto
 */
export interface IEmployeeChoiceDto {
    /**
     * 
     * @type {string}
     * @memberof IEmployeeChoiceDto
     */
    pay_to_type?: IEmployeeChoiceDtoPayToTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof IEmployeeChoiceDto
     */
    payment_method_id?: number;
}

/**
* @export
* @enum {string}
*/
export enum IEmployeeChoiceDtoPayToTypeEnum {
    PARTICIPANT = 'PARTICIPANT',
    PROVIDER = 'PROVIDER',
    CARD_PROCESSOR = 'CARD_PROCESSOR'
}


/**
 * Check if a given object implements the IEmployeeChoiceDto interface.
 */
export function instanceOfIEmployeeChoiceDto(value: object): value is IEmployeeChoiceDto {
    return true;
}

export function IEmployeeChoiceDtoFromJSON(json: any): IEmployeeChoiceDto {
    return IEmployeeChoiceDtoFromJSONTyped(json, false);
}

export function IEmployeeChoiceDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IEmployeeChoiceDto {
    if (json == null) {
        return json;
    }
    return {
        
        'pay_to_type': json['pay_to_type'] == null ? undefined : json['pay_to_type'],
        'payment_method_id': json['payment_method_id'] == null ? undefined : json['payment_method_id'],
    };
}

export function IEmployeeChoiceDtoToJSON(json: any): IEmployeeChoiceDto {
    return IEmployeeChoiceDtoToJSONTyped(json, false);
}

export function IEmployeeChoiceDtoToJSONTyped(value?: IEmployeeChoiceDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'pay_to_type': value['pay_to_type'],
        'payment_method_id': value['payment_method_id'],
    };
}

